import rivets from 'rivets';
import BaseView from '../core/baseView';
import PasswordQualityModel from './PasswordQualityModel';

export default BaseView.extend({
  events: {
    'focus input[type=password].quality-connected': 'showWindow',
    'blur input[type=password].quality-connected': 'hideWindow',
    'keyup input[type=password].quality-connected': 'onKeyUp'
  },

  elements: {
    $passwordField: null
  },

  initialize: function() {
    this.elements.$passwordField = this.$el.find(
      'input[type=password].quality-connected'
    );
    this.passwordQualityModel = new PasswordQualityModel();

    // rivets binding
    this.binding = rivets.bind(this.$el.find('.js-password-quality'), {
      viewModel: this.passwordQualityModel
    });
  },

  showWindow: function() {
    this.passwordQualityModel.set('showWindow', true);
  },

  hideWindow: function() {
    this.passwordQualityModel.set('showWindow', false);
  },

  onKeyUp: function() {
    this.passwordQualityModel.check(this.elements.$passwordField.val());
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/PasswordQualityView.js
 **/